import * as Sentry from '@sentry/react';

// Temporarily hardcode DSN for testing - replace with env var once working
const dsn = import.meta.env.VITE_SENTRY_DSN || 'https://5bb52bd993be6005bbd689cba375620c@o4510431402721280.ingest.de.sentry.io/4510431426838608';

if (dsn) {
  console.log('🔍 Sentry: Initializing with DSN:', dsn.substring(0, 20) + '...');
  
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    debug: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      console.log('📤 Sentry: Sending event:', event);
      return event;
    },
  });
  
  console.log('✅ Sentry: Initialized successfully');
  
  // Send a test event to verify setup
  setTimeout(() => {
    console.log('🧪 Sentry: Sending test event...');
    Sentry.captureMessage('Sentry setup test - Application initialized', 'info');
  }, 1000);
} else {
  console.warn('⚠️ Sentry DSN not found. Error tracking will be disabled.');
  console.log('Available env vars:', Object.keys(import.meta.env).filter(key => key.startsWith('VITE_')));
  console.log('All env vars:', import.meta.env);
  console.log('VITE_SENTRY_DSN value:', import.meta.env.VITE_SENTRY_DSN);
}

